import React, { useState } from "react";
import LogoCEA from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import SyncLoader from "react-spinners/SyncLoader";

const RegisterOrientation = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [church, setChurch] = useState("");
  const [city, setCity] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fullName || !email || !phone || !church || !city) {
      Swal.fire({ text: "Please fill all required fields.", icon: "warning", background: "white", color: "black", confirmButtonColor: "#fb3104" });
      return;
    }
    setIsLoading(true);
    try {
      await axios.post("/specialregistration", {
        type: "orientation",
        name: fullName,
        email,
        phoneNumber: phone,
        localChurch: church,
        city,
        message,
      });
      Swal.fire({
        title: "Registration Submitted!",
        text: "Thank you for registering. We will contact you soon.",
        icon: "success",
        background: "white",
        color: "black",
        confirmButtonColor: "#fb3104",
        confirmButtonText: "OK",
      }).then(() => navigate("/"));
    } catch (err) {
      Swal.fire({ text: err.response?.data?.msg || "Something went wrong.", icon: "error", background: "white", color: "black", confirmButtonColor: "#fb3104" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f4f4f4", display: "flex", justifyContent: "center", alignItems: "center", padding: "40px 16px" }}>
      {isLoading && (
        <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(255,255,255,0.8)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}>
          <SyncLoader color="#fb3104" />
        </div>
      )}
      <div style={{ backgroundColor: "#fff", borderRadius: "12px", padding: "40px", width: "100%", maxWidth: "520px", boxShadow: "0 4px 16px rgba(0,0,0,0.1)" }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <img src={LogoCEA} alt="CEA Logo" style={{ width: "64px", height: "64px", objectFit: "contain", marginBottom: "12px" }} />
          <h4 style={{ fontWeight: "700", color: "#fb3104", marginBottom: "4px" }}>Student Orientation Registration</h4>
          <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>Cutting Edge Academy</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Full Name <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="text" className="form-control" value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Your full name" />
          </div>
          <div className="mb-3">
            <label className="form-label">Email <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="example@email.com" />
          </div>
          <div className="mb-3">
            <label className="form-label">WhatsApp Number <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="text" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))} placeholder="628xxxxxxxxx" />
          </div>
          <div className="mb-3">
            <label className="form-label">Local Church <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="text" className="form-control" value={church} onChange={(e) => setChurch(e.target.value)} placeholder="Your local church" />
          </div>
          <div className="mb-3">
            <label className="form-label">City <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="text" className="form-control" value={city} onChange={(e) => setCity(e.target.value)} placeholder="Your city" />
          </div>
          <div className="mb-4">
            <label className="form-label">Message <span style={{ color: "#aaa", fontSize: "12px" }}>(optional)</span></label>
            <textarea className="form-control" rows={3} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Any questions or notes?" />
          </div>
          <button type="submit" style={{ width: "100%", padding: "10px", backgroundColor: "#fb3104", color: "#fff", border: "none", borderRadius: "8px", fontWeight: "700", fontSize: "15px", cursor: "pointer" }}>
            Submit Registration
          </button>
          <button type="button" onClick={() => navigate(-1)} style={{ width: "100%", marginTop: "10px", padding: "10px", backgroundColor: "transparent", color: "#888", border: "1px solid #ddd", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: "pointer" }}>
            Back
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegisterOrientation;
